<script>
import FooterMapPartners from "@js/components/Footer/Components/FooterMapPartners.vue";
import {useThemeStore} from "@js/store/ThemeStore.js";
import {locations} from "@js/map_points.ts"

export default {
    name: "FooterMap",
    components: {FooterMapPartners},
    mounted() {
        if (typeof window !== 'undefined') {
            // Динамически загружаем DGWidgetLoader только на клиенте
            import("@js/DGWidgetLoader.js").then(() => {
                this.initLazyLoad();
            });
        }
    },
    methods: {
        initLazyLoad() {
            const observer = new IntersectionObserver(
                (entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            this.loadMap();
                            observer.disconnect(); // Останавливаем наблюдение, если карта загружена
                        }
                    });
                },
                {
                    threshold: 0.1, // Загружаем карту, когда 10% элемента видно
                }
            );
            observer.observe(this.$refs.map);
        },

        loadMap() {
            // Загружаем карту через API 2ГИС
            DG.then(() => {
                const map = new DG.Map(this.$refs.map, {
                    center: [55.462540, 37.781900], // Координаты центра карты
                    zoom: 11,
                    borderColor: 'none',
                    opt: {city: "moscow"},
                    pos: {lat: 55.462540, lon: 37.781900, zoom: 1},
                });

                // Создание кастомной иконки для основной точки
                const mainMarkerIcon = new DG.Icon({
                    iconUrl: '/assets/map/general_icon.webp', // Путь к вашей иконке
                    iconSize: [32, 32], // Размер иконки
                    iconAnchor: [16, 32], // Точка привязки иконки
                    popupAnchor: [0, -32] // Расположение всплывающего окна
                });

                // Основная точка
                const generalPoint = new DG.Marker([55.462540, 37.781900], { icon: mainMarkerIcon }).addTo(map)
                generalPoint.on('click', () => {
                    const companyUrl = `https://go.2gis.com/Kr2U6`
                    window.open(companyUrl, '_blank')
                });

                // Добавляем маркер
                locations.forEach(point => {
                    const marker = new DG.Marker([point.lat, point.lng]).addTo(map);
                    // marker.on('click', () => {
                    //     const companyUrl = `https://2gis.ru/dolgoprudny/firm/70000001044161243`;
                    //     window.open(companyUrl, '_blank');
                    // });
                })
            });
        },
    },
    setup() {
        const themeStore = useThemeStore();

        return {themeStore}
    }
}
</script>

<template>
    <div class="pt-20">
        <FooterMapPartners/>
        <div class="map-container w-full h-[450px]" ref="map"></div>
    </div>
</template>

<style scoped lang="scss">

</style>
